/* eslint-disable */
// @ts-nocheck

const ca = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
const trim = function (a) {
  return a === null ? '' : `${a}`.replace(ca, '');
};

const parseExpString = function(a) {
  var b, c, d, e, f, g, h, i, j;
  for (g = function(b) {
      throw new Error("You passed an invalid expiration date `" + a + "`. " + (b || "") + "Please pass a string containing a numeric month and year such as `01-17` or `2015 / 05` For more info, see https://stripe.com/docs/stripe.js")
  }
  ,
  "string" != typeof a && g(),
  f = a.split(/[\.\-\/\s]+/g),
  2 !== f.length && g(),
  b = i = 0,
  j = f.length; i < j; b = ++i)
      e = f[b],
      d = parseInt(e),
      isNaN(d) && g("" + f + " is not a number. "),
      d < 1 && g("" + d + " is less than one. "),
      f[b] = d;
  return f[0] > 12 ? (h = f[0],
  c = f[1]) : (c = f[0],
  h = f[1]),
  c > 12 && g("Month must be a number 1-12, not " + c + ". "),
  h < 100 && (h += 2e3),
  [c, h]
}

export const validateExpiry = function(b, c) {
  var d, e, f, g;
  if (null != c)
      f = trim(b),
      c = trim(c);
  else {
      try {
          g = parseExpString(b),
          f = g[0],
          c = g[1]
      } catch (h) {
          return !1
      }
      f += "",
      c += ""
  }
  return !!/^\d+$/.test(f) && (!!/^\d+$/.test(c) && (1 <= f && f <= 12 && (2 === c.length && (c = c < 70 ? "20" + c : "19" + c),
  4 === c.length && (e = new Date(c,f),
  d = new Date,
  e.setMonth(e.getMonth() - 1),
  e.setMonth(e.getMonth() + 1, 1),
  e > d))))
}